import React from 'react';
import PropTypes from 'prop-types';
import * as Style from './style';
import Button from '../Button';
import Car from '../../../img/car2.png';
import CarBlack from '../../../img/chevrolet-4-onix-premier-preto-ouro-negro.png';
import CarRed from '../../../img/Vermelho-Glory.png';

const Banner = ({ hasProduct }) => (hasProduct ? (
	<Style.BannerBackground>
		<div className="d-flex flex-column justify-content-center" style={{ height: '100%' }}>
			<Style.MainText>A agência da Webmotors pra você</Style.MainText>
			<Style.Text>Tudo o que você precisa para fazer sua loja <br />bombar suas vendas</Style.Text>
		</div>
		<Style.CarImg src={CarRed} alt="" zindex="0" />
		<Style.CarImg src={CarBlack} alt="" zindex="1" />
	</Style.BannerBackground>
) : (
	<Style.BannerBackground>
		<img src={Car} alt="/" />
		<Style.Banner>
			<div className="row">
				<div className="col-12">
					<div className="row">
						<div className="col-12">
							<Style.Title>CAMPANHAS!</Style.Title>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<Style.Text>
								Bem-vindo ao produto Webmotors que fará a sua loja bombar em vendas! <br /> {}
								Aqui ficam as soluções para promover e impulsionar sua loja na internet! <br /> {}
								Alcance seus clientes, onde quer que eles estejam!
							</Style.Text>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<Button style={{ width: '292px', height: '40px' }} type="link" to="/campanhas/nova-campanha">Crie sua campanha agora mesmo</Button>
						</div>
					</div>
				</div>
			</div>
		</Style.Banner>
	</Style.BannerBackground>
    ));
Banner.defaultProps = {
    hasProduct: false,
};

PropTypes.Banner = {
    hasProduct: PropTypes.boolean,
};

export default Banner;
